import type { Dayjs } from "dayjs";
import { useCallback, useState } from "react";
import { Severity } from "type";
import { getUserType } from "util/auth";
import dayjs from "dayjs";
import downloadSystemUsageApi from "../api/downloadSystemUsageApi";
import type { SystemUsageParams } from "../types";
import { INVALID_DATE } from "../constants";

/**
 * Custom hooks to use system usage as CSV.
 * @param showAlert アラート表示
 */
export default function useSystemUsageDownload(showAlert: (msg: string, severity?: Severity) => void) {
  const [target, setTarget] = useState<number>();
  const [dateFrom, setDateFrom] = useState<Dayjs | null>(dayjs().startOf("month"));
  const [dateTo, setDateTo] = useState<Dayjs | null>(dayjs());
  const [companyCd, setCompanyCd] = useState<string>("");
  const [storeCd, setStoreCd] = useState<string>("");

  // const [storeName, setStoreName] = useState("");
  // const [startDate, setStartDate] = useState<Dayjs | null>(null);
  // const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [isLoading, setIsloading] = useState<boolean>(false);

  const handleDownload = useCallback(async () => {
    if (!dateFrom || !dateTo) {
      showAlert("開始日と終了日を指定してください", "error");
      return;
    }
    if (dateFrom.format("YYYY-MM-DD") === INVALID_DATE || dateTo.format("YYYY-MM-DD") === INVALID_DATE) {
      showAlert("開始日と終了日を正しく指定してください", "error");
      return;
    }
    let tar = target;
    if (!target) {
      const userType = getUserType();
      // 店舗が選択されていないとき
      switch (userType) {
        case "C0001":
          tar = 4; // 本部が対象
          break;
        case "C0006":
          tar = 3; // 企業が対象
          break;
        case "C0002":
          tar = 1; // 店舗が対象
          break;
        case "C0003":
          tar = 2; // 得意先が対象
          break;
        default:
          tar = 1; // デフォルトは店舗が対象
          break;
      }
    }

    setIsloading(true);
    try {
      // const safeTarget = target ?? 1;
      const params: SystemUsageParams = {
        target: tar as number,
        dateFrom: dateFrom.format("YYYY-MM-DD"),
        dateTo: dateTo.format("YYYY-MM-DD"),
        companyCd,
        storeCd,
      };
      await downloadSystemUsageApi(params, showAlert);

      // const blob = await downloadSystemUsageApi(params);
      // const url = window.URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `system-usage_${params.startDate}_${params.endDate}.csv`;
      // a.click();
      // window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("CSVのダウンロードに失敗しました");
    } finally {
      setIsloading(false);
    }
  }, [target, dateFrom, dateTo, companyCd, storeCd]);

  return {
    // storeName,
    // setStoreName,
    // startDate,
    // setStartDate,
    // endDate,
    // setEndDate,
    // handleDownload,
    // isLoading,

    setTarget,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    companyCd,
    setCompanyCd,
    storeCd,
    setStoreCd,
    handleDownload,
    isLoading,
  };
}
